import { GetProductData } from 'core/cta';

import middleware from '../drivers/middleware';

const getProductData: GetProductData = ({ productId, skuId, locale = 'en' }) => {
  return middleware()('0', 'getProduct', {
    productId,
    skuId,
    locale,
  });
};

export default getProductData;
